import { Formatter } from "./Formatter";

export class CnpjFormatter implements Formatter {

  constructor(private readonly cnpj: string) { }

  public readonly format = () => this.cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");

}